import utils from './utils';
import Choices from 'choices.js';

/* -------------------------------------------------------------------------- */
/*                                   choices                                   */
/* -------------------------------------------------------------------------- */
export const selectJsChoicesInit = () => {
  // Forms validation
  const forms = document.querySelectorAll('.needs-validation');

  for (const form of forms) {
    const selectFormValidation = () => {
      form.querySelectorAll('.choices').forEach((choicesItem) => {
        const singleSelect = choicesItem.querySelector(
          '.choices__list--single'
        );
        const multipleSelect = choicesItem.querySelector(
          '.choices__list--multiple'
        );

        if (choicesItem.querySelector('[required]')) {
          if (singleSelect) {
            const dataValue = singleSelect
              .querySelector('.choices__item--selectable')
              ?.getAttribute('data-value')

            if ( dataValue && dataValue !== '') {
              choicesItem.classList.remove('invalid');
              choicesItem.classList.add('valid');
            } else {
              choicesItem.classList.remove('valid');
              choicesItem.classList.add('invalid');
            }
          }
          //----- for multiple select only ----------
          if (multipleSelect) {
            if (choicesItem.getElementsByTagName('option').length) {
              choicesItem.classList.remove('invalid');
              choicesItem.classList.add('valid');
            } else {
              choicesItem.classList.remove('valid');
              choicesItem.classList.add('invalid');
            }
          }

          //------ select end ---------------
        }
      });
    };

    const submitButtons = form.querySelectorAll("button[type=submit]") ?? []
    for (const button of submitButtons) {

      // Handle submit event
      button.addEventListener(
        "click",
        (event) => {
          selectFormValidation();
        },
        true
      )
    }

    const selects = form.querySelectorAll('.js-choice');
    for (const item of selects) {
      const userOptions = utils.getData(item, 'options');
      const choices = new Choices(item, {
        itemSelectText: '',
        ...userOptions,
      });

      item.addEventListener('change', () => {
        selectFormValidation();
      });
    }

    form.addEventListener('submit', () => {
      selectFormValidation();
    }, true);
  }
}
